import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

/**
 * Utilidades para validación de formularios
 */

/**
 * Valida que dos campos sean iguales (para confirmar contraseña)
 */
export function matchValidator(matchTo: string, reverse?: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (control.parent && reverse) {
      const c = (control.parent?.controls as any)[matchTo] as AbstractControl;
      if (c) {
        c.updateValueAndValidity();
      }
      return null;
    }
    return !!control.parent &&
      !!control.parent.value &&
      control.value === (control.parent?.controls as any)[matchTo].value
      ? null
      : { matching: true };
  };
}

/**
 * Valida contraseña fuerte
 */
export function strongPasswordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const hasUpperCase = /[A-Z]+/.test(value);
    const hasLowerCase = /[a-z]+/.test(value);
    const hasNumeric = /[0-9]+/.test(value);
    const hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/.test(value);
    const isLengthValid = value.length >= 8;

    const passwordValid = hasUpperCase && hasLowerCase && hasNumeric && hasSpecialChar && isLengthValid;

    return !passwordValid ? { strongPassword: true } : null;
  };
}

/**
 * Valida que no contenga espacios
 */
export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const isWhitespace = (control.value || '').trim().length === 0;
    const isValid = !isWhitespace;
    return isValid ? null : { whitespace: true };
  };
}

/**
 * Valida email con patrón personalizado
 */
export function emailValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const isValid = emailPattern.test(value);

    return isValid ? null : { email: true };
  };
}

/**
 * Valida que solo contenga números
 */
export function numericValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (!value) {
      return null;
    }

    const isValid = /^[0-9]+$/.test(value);
    return isValid ? null : { numeric: true };
  };
}

/**
 * Valida rango de números
 */
export function rangeValidator(min: number, max: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    const isValid = numValue >= min && numValue <= max;

    return isValid ? null : { range: { min, max } };
  };
}

/**
 * Valida que el valor sea una entidad seleccionada (objeto con id/@id o IRI).
 * Permite números, objetos con id, objetos con @id/iri y strings con /<id>.
 */
export function selectedEntityValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;
    if (value === null || value === undefined || value === '') {
      return null;
    }

    if (typeof value === 'number') {
      return null;
    }

    if (typeof value === 'object') {
      if ((value as any).id) {
        return null;
      }
      const iri = (value as any)['@id'] || (value as any).iri;
      if (typeof iri === 'string' && /\/\d+$/.test(iri)) {
        return null;
      }
      return { selectedEntity: true };
    }

    if (typeof value === 'string') {
      return /\/\d+$/.test(value) ? null : { selectedEntity: true };
    }

    return { selectedEntity: true };
  };
}
